import React from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { Message } from "primereact/message";

const RevisarDenominacion = (props) => {
  const { solicitud } = props;
  return (
    <>
      <div className="card">
        <Fieldset legend="Solicitud de Reserva Denominación">
          <div className="formgrid grid">
            <div className="field col-12 md:col-6">
              <div className="col">
                <label className="font-semibold">Denominación: </label>
                <div className="font-bold uppercase m-2">
                  {solicitud.nomCatTipoCaja + " - " + solicitud.nomParticular}
                </div>
              </div>
              <div className="col">
                <label htmlFor="traduccion">Traducción al Castellano:</label>
                <InputTextarea
                  id="traduccion"
                  name="traduccion"
                  value={solicitud?.txtTraduccionCastellano ?? ""}
                  rows={2}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>

              <div className="col">
                <div className="font-semibold uppercase m-2">
                  Su Razón Social será: {solicitud.nomCatTipoCaja + " " + solicitud.nomParticular}
                </div>
              </div>
            </div>
            <div className="field col-12 md:col-6">
              <div className="field col-12 md:col-12">
                <label htmlFor="nombreParticular">Nombre particular:</label>
                <InputTextarea
                  id="nombreParticular"
                  name="nombreParticular"
                  value={solicitud?.nomParticular ?? ""}
                  disabled
                  rows={2}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col">
                {solicitud.lstMensaje?.length > 0 &&
                  solicitud.lstMensaje?.map((item, index) => (
                    <Message key={index} severity="warn" className="mb-2" text={item.mensaje} />
                  ))}
              </div>
            </div>

            <div className="field col-12 md:col-12">
              <label htmlFor="observaciones">Observaciones:</label>
              <InputTextarea
                id="observaciones"
                name="observaciones"
                value={solicitud?.txtObservacion ?? ""}
                disabled
                rows={3}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Fieldset>
      </div>
    </>
  );
};
export default RevisarDenominacion;
